import { AppLayout } from "../shared";
import MasterOrgEditAdvertisement from "../MasterOrg/MasterOrgEditAdvertisement";

const MasterOrgEditAdvertisement_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <MasterOrgEditAdvertisement props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgEditAdvertisement_layout;
